import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { BaseService } from './base.service';
import { OperatoreImpianto } from '../models/operatoreImpianto';

@Injectable()
export class OperatoreService extends BaseService {

  getOperatoriByImpianto(): Observable<OperatoreImpianto[]> {
    return this.get('api/OperatoreImpianto/OperatoriImpiantoByImpianto')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Operatori;
      });
  }

  getOperatoreByImpianto(OperatoreId: number): Observable<OperatoreImpianto> {
    return this.get('api/OperatoreImpianto/OperatoreImpiantoByImpianto/' + OperatoreId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getOperatoriByCliente(): Observable<OperatoreImpianto[]> {
    return this.get('api/OperatoreImpianto/OperatoriImpiantoByCliente')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Operatori;
      });
  }
  
  isUserOperatoreTotem(): Observable<boolean> {
    return this.get('api/OperatoreImpianto/IsUserOperatoreTotem')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putOperatore(Form: OperatoreImpianto): Observable<boolean> {
    return this.put('api/OperatoriImpianto/' + Form.Id, Form)
      .catch((error: any) => {
        console.log("putOperatoreImpianto: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  postOperatore(Form: OperatoreImpianto): Observable<boolean> {
    return this.post('api/OperatoreImpianto', Form)
      .catch((error: any) => {
        console.log("postOperatore: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  deleteOperatore(OperatoreId): Observable<boolean> {
    return this.delete('api/OperatoreImpianto/' + OperatoreId)
      .catch((error: any) => { console.log("deleteOperatoreImpianto: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putModificaCarta(IdOperatore, IdCarta, ForzaAssegnazioneCarta): Observable<boolean> {
    return this.put('api/OperatoreImpianto/' + IdOperatore + '/PutModificaCartaByImpianto', { IdCarta: IdCarta, ForzaAssegnazioneCarta: ForzaAssegnazioneCarta })
      .catch((error: any) => {
        console.log("putModificaCartaByImpianto: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/operatore.service.ts